import React from 'react';
import Slider from 'react-rangeslider';
import {useState} from 'react';
import { getLabel } from '../../language'
import {COMMENT_MAX_CHARACTER} from "../../constants/actionTypes";

const VoteItem = props => {
    let show = typeof props.show !== 'undefined' ? props.show : true;
    let disabled = "disabled";
    const id = `remember-${props.personId}`;
    return (
        <div hidden={!show}>
            <div className="row">
                <div className="col-md-12">
                    <h5 className={`text-center ${props.anonymous ? "cw" : ""}`}> {props.disabled && props.isFinal ? getLabel(241) : null} {props.title}</h5>
                </div>
            </div>

            <div className="row">

              <div className={`${props.disabled && "isDisabled"} col-md-12 thumbvote d-flex flex-row mb-2`} >
                <a onClick={(e) => props.onLikeSubmit(e, props.mayBe)}
                   name="mayBe"
                   className="pointer"
                   id={props.vote === "U" ? "maybe-voted" : "maybe"}>{props.mayBe}%</a>
                <a onClick={(e) => props.onLikeSubmit(e, props.downVote)}
                   name="downVote"
                   className="pointer"
                   id={props.vote === "A" ? "downvote-voted" : "downvote"}>{props.downVote}%</a>
                <a onClick={(e) => props.onLikeSubmit(e, props.upVote)}
                   name="upVote"
                   className="pointer"
                   id={props.vote === "F" ? "upvote-voted" : "upvote"}>{props.upVote}%</a>
              </div>

              <div className="col-md-12">
                <textarea className={`form-control${props.anonymous ? "-dark" : ""} with-border`}
                          name="polliesComment"
                          value={props.polliesComment ? props.polliesComment : ""}
                          disabled = {props.disabled && disabled}
                          onChange={(e) => props.onChange(e)}
                          placeholder={getLabel(109)}/>
                <span className='election-page-comment-range'>{props?.charsLeft}/{props?.maxChar}</span>
              </div>
            </div>

            <div className="row">
                <div className="col-md-3 vote-col-name">
                    <span>{getLabel(111)} ({props.vision})</span>
                </div>
                <div className="col-md-9">
                    <Slider
                        className={props.disabled || props.vote === 'U' ? 'disable-vote' : ''}
                        min={1}
                        max={10}
                        step={1}
                        value={props.vision || 0}
                        orientation="horizontal"
                        onChange={props.disabled || props.vote === 'U' ? null : (e) => props.onVisionChange(e,'vision')}
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-md-3 vote-col-name">
                    <span>{getLabel(110)} ({props.ability})</span>
                </div>
                <div className="col-md-9">
                    <Slider
                        className={props.disabled || props.vote === 'U' ? 'disable-vote' : ''}
                        min={1}
                        max={10}
                        step={1}
                        value={props.ability || 0}
                        orientation="horizontal"
                        onChange={props.disabled || props.vote === 'U' ? null : (e) => props.onAbilityChange(e,'ability')}
                    />
                </div>
            </div>
            <div className="row">
                <div className="vote-col-name">
                    <div className="checkboxgroup black">
                        <input type="checkbox" id={id}
                               checked={props.isFinal}
                               disabled={!!props.disabled}
                               className="className"
                               onChange={props.onChange}
                               name="isFinal" />
                        <label htmlFor={id}>{getLabel(243)} {props.isParty ? getLabel(244) : getLabel(245)}.</label>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VoteItem;
